const addDaysAndFormatDate = () => {
  const date = new Date()
  const dateAdded = date.setDate(new Date().getDate() + 30)
  return new Date(dateAdded).toLocaleDateString('fr-CA') // yyyy-mm-dd
}

export default addDaysAndFormatDate
